import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSmsWasSent = wasSent => ({
  type: actionTypes.SET_ADD_AD_SMS_WAS_SENT,
  payload: wasSent
})
